export default __webpack_public_path__ + "static/media/ngo02.5421d67c.jpg";